import { sortNumberFunction, sortStringFunction } from '../../../../utils/sort';
import { EnumReportDishSortField } from '../../../../constants/enum';

export const sortReportDish = (table, sort, sortOrder) => {
  const { itemList } = table;

  if (itemList.length === 0) { return; }

  switch (sort) {
    case EnumReportDishSortField.DISH.id: {
      const nestedField = 'name';
      itemList.sort(sortStringFunction(nestedField, sortOrder));
      break;
    }
    case EnumReportDishSortField.QUANTITY.id: {
      const nestedField = 'dish_sum';
      itemList.sort(sortNumberFunction(nestedField, sortOrder));
      break;
    }
    default:
      break;
  }
};


// WEBPACK FOOTER //
// ./foody/src/pages/Order/ReportDish/components/utils.js